export default {
  "changelog.title": "Muutoshistoria",
  "changelog.operation.insert": "Luotu",
  "changelog.operation.update": "Muokattu",
  "changelog.operation.delete": "Poistettu",
  "changelog.no_changes": "Ei muutoksia",
  "changelog.changed_fields": "Muutetut kentät",
  "changelog.unknown_user": "Tuntematon käyttäjä",
};
